import React, { useMemo } from 'react';
import { GoogleMap, Marker, useLoadScript, OverlayView } from '@react-google-maps/api';

// CSS
import '../styles/map.css';

const containerStyle = {
  width: '100%',
  height: '300px'
};

// Default center (Philippines)
const DEFAULT_LOCATION = {
  lat: 12.8797,
  lng: 121.7740,
};

const mapOptions = {
  disableDefaultUI: true,
  zoomControl: false,
  streetViewControl: false,
  mapTypeControl: false,
  fullscreenControl: false,
  clickableIcons: false,
};



const Maps = ({ location = {} }) => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_MAPS_API_KEY,
  });

 
    const { lat, lng, isValidLocation, pinLocation } = useMemo(() => {
      let lat = null;
      let lng = null;

      if (typeof location === 'string') {
        const match = location.match(/LATITUDE=([\d.-]+),\s*LONGITUDE=([\d.-]+)/);
        if (match) {
          lat = parseFloat(match[1]);
          lng = parseFloat(match[2]);
        }
      } else if (typeof location === 'object' && location !== null) {
        lat = parseFloat(location.latitude);
        lng = parseFloat(location.longitude);
      }

      const isValidLat = !isNaN(lat) && lat >= -90 && lat <= 90;
      const isValidLng = !isNaN(lng) && lng >= -180 && lng <= 180;
      const isValidLocation = isValidLat && isValidLng;

      return {
        lat,
        lng,
        isValidLocation,
        pinLocation: isValidLocation
          ? { lat, lng }
          : { lat: 12.8797, lng: 121.774 }, // Default center (e.g., Philippines)
      };
    }, [location]);

   
    if (!isLoaded) return <div>Loading map...</div>;


  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={pinLocation}
      zoom={isValidLocation ? 11 : 5}
      options={mapOptions}
    >
      {isValidLocation && (
        <>
          {/* Pulsing effect behind the pin */}
          <OverlayView
            position={pinLocation}
            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
          >
            <div className="pulse-effect"></div>
          </OverlayView>

          {/* Default pin marker on top */}
          <Marker position={pinLocation} />
        </>
      )}
    </GoogleMap>
  );
};

export default Maps;
